import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { Tile } from "@dash/tile";
import { useTheme } from "@emotion/react";
import React, { useState } from "react";
import { MdOutlineContacts } from "react-icons/md";

import { useClientManager } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

type Props = {
  customerId: Uuid;
};

export const CrmCustomerContacts: React.FC<Props> = ({ customerId }) => {
  const theme = useTheme();

  const contactsQuery = useClientManager("crm")
    .customerContactsQuery()
    .useQuery({ customerId });

  const contacts = contactsQuery.data ?? [];
  const [selectedContactId, setSelectedContactId] = useState<string | null>(null);
  const selectedContact = contacts.find((contact) => contact.uuid === selectedContactId) ?? null;

  if (contacts.length === 0) return null;

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      {contacts.map((c) => (
        <Tile
          key={c.uuid}
          onClick={() => setSelectedContactId(c.uuid)}
          css={{ cursor: "pointer" }}
          stripe={
            <div
              css={{
                color: theme.colors.primary,
                background: "transparent",
                opacity: 0.15,
                padding: "0.5rem 0.875rem",
                alignSelf: "stretch",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRight: `1px solid rgba(0,0,0,0.08)`,
              }}
            >
              <MdOutlineContacts size={18} />
            </div>
          }
        >
          <div css={{ display: "flex", flexDirection: "column", gap: "0.125rem", minWidth: 0 }}>
            <span css={{ fontSize: "0.875rem", fontWeight: 600, minWidth: 0 }}>{c.name}</span>
            {c.jobTitle && <span css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>{c.jobTitle}</span>}
          </div>
        </Tile>
      ))}
      {selectedContact && (
        <Dialog
          header={selectedContact.name}
          onClose={() => setSelectedContactId(null)}
          footer={
            <div css={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="outline" onClick={() => setSelectedContactId(null)}>
                Zamknij
              </Button>
            </div>
          }
        >
          <div css={{ display: "flex", flexDirection: "column", gap: "0.75rem", minWidth: "20rem" }}>
            {selectedContact.jobTitle && (
              <div>
                <div css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>Stanowisko</div>
                <div css={{ fontSize: "0.875rem" }}>{selectedContact.jobTitle}</div>
              </div>
            )}
            {selectedContact.phoneNumber && (
              <div>
                <div css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>Telefon</div>
                <a href={`tel:${selectedContact.phoneNumber.replace(/\s/g, "")}`} css={{ fontSize: "0.875rem", color: theme.colors.primary }}>
                  {selectedContact.phoneNumber}
                </a>
              </div>
            )}
            {selectedContact.email && (
              <div>
                <div css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>Email</div>
                <a href={`mailto:${selectedContact.email}`} css={{ fontSize: "0.875rem", color: theme.colors.primary }}>
                  {selectedContact.email}
                </a>
              </div>
            )}
          </div>
        </Dialog>
      )}
    </div>
  );
};
